import { useAppSearchParams } from "@/routing/navigation";

export default function useSubuserId() {
  // `getAll` preserves the old behaviour exactly: absent, repeated, or empty
  // all resolved to null when this read Next's merged `query` object.
  const values = useAppSearchParams().getAll("subuser");

  if (values.length !== 1 || values[0].length === 0) return null;

  return values[0];
}
